window.moment = require('moment');

import { createApp } from 'vue';
import InterviewDate from './components/common/DatepickerComponent.vue';
import InterviewTime from './components/common/TimepickerComponent.vue';
import moment from 'moment';

const app = createApp({
    components: {
        'datepicker-component': InterviewDate,
        'timepicker-component': InterviewTime
    },
    data() {
        return {
            old: Object,
            errors: Object|Array
        }
    }
})

app.use(moment);
app.mount('#interview-form')